import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

export default function ScrollHero() {
    const ref = useRef(null);
    const { scrollYProgress } = useScroll({
        target: ref,
        offset: ["start start", "end start"],
    });

    // Pure wordmark moment — no secondary hero reveal.
    const scale = useTransform(scrollYProgress, [0.1, 0.9], [1, 0.5]);
    const opacity = useTransform(scrollYProgress, [0.5, 0.95], [1, 0]);
    const letterSpacing = useTransform(
        scrollYProgress,
        [0.1, 0.9],
        ["-0.04em", "-0.02em"]
    );
    const bgOpacity = useTransform(scrollYProgress, [0, 0.8], [1, 0.4]);
    const topFade = useTransform(scrollYProgress, [0, 0.4], [1, 0]);

    return (
        <section
            ref={ref}
            data-testid="scroll-hero"
            className="relative w-full"
            style={{ height: "120vh" }}
            id="top"
        >
            <div className="sticky top-0 h-screen w-full overflow-hidden grain bg-white">
                <motion.div
                    style={{ opacity: bgOpacity }}
                    className="absolute inset-0 blueprint-grid"
                />
                <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_rgba(30,107,255,0.10)_0%,_transparent_60%)] pointer-events-none" />

                {/* Top meta strip */}
                <motion.div
                    style={{ opacity: topFade }}
                    className="absolute top-20 md:top-24 left-0 right-0 px-6 md:px-12 flex items-center justify-between text-[11px] tracking-[0.25em] uppercase text-[#0A1F44]/50 font-medium"
                >
                    <span data-testid="hero-tagline-left">
                        Data · Insights
                    </span>
                    <span className="hidden md:inline">
                        Home Buying Intelligence
                    </span>
                    <span data-testid="hero-tagline-right">
                        Better Decisions
                    </span>
                </motion.div>

                {/* HomeIQ — sole hero moment */}
                <motion.div
                    style={{ scale, opacity, letterSpacing }}
                    className="absolute inset-0 flex items-center justify-center pointer-events-none"
                >
                    <h1
                        data-testid="hero-wordmark"
                        className="font-display font-black select-none whitespace-nowrap leading-[0.85]"
                        style={{ fontSize: "clamp(6rem, 22vw, 22rem)" }}
                    >
                        <span className="text-outline-navy">Home</span>
                        <span className="text-outline-blue">IQ</span>
                    </h1>
                </motion.div>

                {/* Scroll cue → bridges into the rent discovery experience */}
                <motion.div
                    style={{ opacity: topFade }}
                    className="absolute bottom-5 left-1/2 -translate-x-1/2 text-[10px] tracking-[0.3em] uppercase text-[#0A1F44]/50 flex flex-col items-center gap-2 font-medium pointer-events-none"
                >
                    <span>Scroll to begin</span>
                    <span className="block w-px h-8 bg-gradient-to-b from-[#0A1F44]/50 to-transparent" />
                </motion.div>
            </div>
        </section>
    );
}
